import React from 'react';
import { SuggestTextCellEditor } from '@ui/text';
import { AutodocType, coreActions } from '@sonar-software/sonar-core';
import { useAction, useSonarObjectReference } from '@hooks';

export interface DefinitionColumnProps {
	sonarObjectId: number;
	getPopupContainer?: (trigger: HTMLElement) => HTMLElement;
}

export const DefinitionColumn: React.FC<DefinitionColumnProps> = ({ sonarObjectId, getPopupContainer }) => {
	const definition = useSonarObjectReference(sonarObjectId)?.context?.definition ?? '';

	const updateSonarObjectContext = useAction(coreActions.requestPatchCoreSonarObjectsContext);

	const handleSave = (content: string) => {
		updateSonarObjectContext({
			context: { definition: content },
			sonarObjectId
		});
	};

	return (
		<SuggestTextCellEditor
			autodocType={ AutodocType.Definition }
			canBeEmpty
			getPopupContainer={ getPopupContainer }
			onSave={ handleSave }
			sonarObjectId={ sonarObjectId }
			value={ definition } />
	);
};
